<template>
  <div class="p-4">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Designations</h4>
          </div>
          <div class="col-6 text-right">
            <appModalDesignationNew></appModalDesignationNew>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>

          <div class="status-box item">
            <label for="paginate" class="mb-0">Status</label>
            <select
              v-model="selectedStatus"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All Status</option>
              <option value="N">In-active</option>
              <option value="Y">Active</option>
            </select>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item v-th-80">
                  <a href="#" @click.prevent="fnChangeSort('id')">Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('name')"
                    >Designation</a
                  >
                </th>
                <th class="header-item v-th-center v-th-80">
                  <a href="#" @click.prevent="fnChangeSort('status')">Status</a>
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'status'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'status'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center v-th-80">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, index) in getDesignationPaginateData.data">
                <tr :key="(row, index)">
                  <td>{{ row.id }}</td>
                  <td>{{ row.name }}</td>
                  <td class="v-td-center">
                    <div v-if="row.status == 'N'">
                      <span class="badge bdg-draft">In-active</span>
                    </div>
                    <div v-if="row.status == 'Y'">
                      <span class="badge bdg-new">Active</span>
                    </div>
                  </td>

                  <td class="v-td-center">
                    <div class="d-flex">
                      <appModalDesignationEdit
                        :propsData="row"
                      ></appModalDesignationEdit>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Pagination -->
              <tr>
                <td colspan="5">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getDesignationPaginateData"
                        @pagination-change-page="fnGetList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from 'laravel-vue-pagination'
import { mapGetters, mapActions } from 'vuex'
import appModalDesignationNew from '../../../components/settings/ModalDesignationNew.vue'
import appModalDesignationEdit from '../../../components/settings/ModalDesignationEdit.vue'

export default {
  name: 'DesignationList',
  components: {
    pagination,
    appModalDesignationNew,
    appModalDesignationEdit
  },
  data() {
    return {
      opened: [],
      recordsPerPage: 15,
      page: 1,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'id',
      paginate: {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'id'
      }
    }
  },
  computed: {
    ...mapGetters(['getDesignationPaginateData', 'getDesignationPaginate'])
  },
  methods: {
    ...mapActions(['fetchDesignationPaginate']),
    fnGetList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchDesignationPaginate(objNew)
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchDesignationPaginate(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchDesignationPaginate(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchDesignationPaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''
      let obj1 = this.paginate
      let obj2 = {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'id'
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchDesignationPaginate(objNew)
    }
  },

  mounted() {
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'id'
    }
    let objNew = { ...obj1, ...obj2 }
    this.fetchDesignationPaginate(objNew)
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>
